import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  bulkPackageSizes,
  PDASCANCELREASONS,
} from 'src/@order/commonData/commonUiData';
import { AuthServiceLocal } from 'src/@order/services/auth.service';
import { interRegionalOrder } from 'src/app/utils/systemEnums';
import { MatDialog } from '@angular/material/dialog';
import { CancelOrderReasonsComponent } from 'src/@order/dialogs/cancel-order-reasons/cancel-order-reasons.component';

@Component({
  selector: 'app-order-inter-regional-details',
  templateUrl: './order-inter-regional-details.component.html',
  styleUrls: ['./order-inter-regional-details.component.scss'],
})
export class OrderInterRegionalDetailsComponent implements OnInit {
  countryFromLocal = localStorage.getItem('country');
  order: any = null;
  isLoading: boolean = true;
  error: string = '';
  orderId: string = '';
  orderDetail: any = null;
  dropDetail: any = null;
  country: string = 'Ghana';
  expandedDropoffs: boolean[] = [];
  driver: any;
  orderLink: string = '';
  isCancelingOrder: boolean = false;
  totalCashCollected: number = 0;

  packageItems = [
    {
      id: 1,
      title: 'Fruits',
      images: 'assets/images/icons/fruits.png',
      isSelected: false,
    },
    {
      id: 2,
      title: 'Furniture',
      images: 'assets/images/icons/furniture.png',
      isSelected: false,
    },
    {
      id: 3,
      title: 'HouseHold Items',
      images: 'assets/images/icons/household.png',
      isSelected: false,
    },
    {
      id: 4,
      title: 'Laptops/Computers',
      images: 'assets/images/icons/laptop.png',
      isSelected: false,
    },
    {
      id: 5,
      title: 'Documents',
      images: 'assets/images/icons/documents.png',
      isSelected: false,
    },
    {
      id: 6,
      title: 'Cloths/Fashion Accessories',
      images: 'assets/images/icons/cloths.png',
      isSelected: false,
    },
    {
      id: 7,
      title: 'Office Accessories',
      images: 'assets/images/icons/office.png',
      isSelected: false,
    },
    {
      id: 8,
      title: 'Warehouse Pickup',
      images: 'assets/images/icons/warehouse.png',
      isSelected: false,
    },
  ];

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _authService: AuthServiceLocal,
    private afs: AngularFirestore,
    private _snackBar: MatSnackBar,
    private _matDialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.orderId = this._route.snapshot.params['id'];
    if (this.orderId) {
      this.loadOrderDetails();
      this.loadDriverDetails();
    } else {
      this.error = 'Order ID not found';
      this.isLoading = false;
    }
  }

  public GetInterRegionalStatus(status) {
    switch (status) {
      case 1:
        return 'Processing';
      case 2:
        return 'In transit';
      case 3:
        return 'Delivered';
      case 4:
        return 'Cancelled';
      case 5:
        return 'Re-Scheduled';
      case 6:
        return 'In Transit Hold';
      case 7:
        return 'Returned';
      case 8:
        return 'Enroute to PickUp';
      default:
        return 'Processing';
    }
  }

  public GetInterRegionalStatusClass(status) {
    switch (status) {
      case 1:
        return '!text-[#007bff] !border !border-[#007bff]';
      case 2:
        return '!text-[#F38211] !border !border-[#F38211]';
      case 3:
        return '!text-[#2CA13F] !border !border-[#2CA13F]';
      case 4:
        return '!text-red !border !border-red';
      case 5:
        return '!text-[#F38211] !border !border-[#F38211]';
      case 6:
        return '!text-[#F38211] !border !border-[#F38211]';
      case 7:
        return '!text-red !border !border-red';
      case 8:
        return '!text-[#F38211] !border !border-[#F38211]';
      default:
        return '!text-[#007bff] !border !border-[#007bff]';
    }
  }

  public onCancelOrder() {
    const dialog = this._matDialog.open(CancelOrderReasonsComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      autoFocus: false,
      disableClose: false,
      width: '610px',
      data: {
        reasons: PDASCANCELREASONS,
        heading: 'Select Reason',
      },
    });

    dialog.afterClosed().subscribe((res: any) => {
      if (res) {
        this.isCancelingOrder = true;
        res['orderId'] = this.orderId;
        this._authService
          .onCancelInterRegionalOrder(res)
          .subscribe((result: any) => {
            if (result.response == 1) {
              this._snackBar.open(result.message, 'OKAY', {
                duration: 3000,
              });
              this.isCancelingOrder = false;
              this.loadOrderDetails();
              // Refresh dashboard data (wallet, etc.) after successful cancel
              this._authService.getDashboardData();
            } else {
              this._snackBar.open(result.message, 'OKAY', {
                duration: 3000,
              });
              this.isCancelingOrder = false;
            }
          });
      }
    });
  }

  loadOrderDetails() {
    this.isLoading = true;
    this.error = '';

    this._authService.getInterRegionalOrderDetail(this.orderId).subscribe({
      next: (response: any) => {
        console.log('response', response);
        if (response && response.data) {
          this.mapApiResponseToOrder(response.data);
        } else {
          this.error = 'No order data found';
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading order details:', error);
        this.error = 'Failed to load order details. Please try again.';
        this.isLoading = false;
      },
    });
  }

  private async loadDriverDetails() {
    try {
      const docRef = this.afs.collection(interRegionalOrder).doc(this.orderId);
      const docSnapshot = await docRef.get().toPromise();

      if (docSnapshot.exists) {
        const data: any = docSnapshot.data();
        console.log('Document data:', data, this.orderId);
        this.driver = data.driver;
        this.orderLink = data.orderLink;
        this.totalCashCollected = data.totalCashCollected;
      } else {
        console.log('No such document!');
      }
    } catch (error) {
      console.error('Error fetching Firebase document:', error);
    }
  }

  handleZeroDriverNumber(number) {
    // const customNumber = number;
    // if(this.selectedCountryCode == '+233'){
    if (
      String(number).startsWith('+2330') ||
      String(number).startsWith('+2340')
    ) {
      return (
        String(number).split('').slice(0, 4).join('') +
        String(number).split('').slice(5, String(number).length).join('')
      );
    } else {
      return number;
    }
    // }else{
    // if(String(customNumber).startsWith('+2340')){
    //   return String(customNumber).split('').slice(0,4).join('') + String(customNumber).split('').slice(5,String(customNumber).length).join('')
    // }else{
    //   return customNumber
    // }
    // }
  }

  mapApiResponseToOrder(apiData: any) {
    this.orderDetail = apiData.orderDetail;
    this.dropDetail =
      apiData.dropDetail && apiData.dropDetail.length > 0
        ? apiData.dropDetail
        : [];
    this.country = this.orderDetail['LOWER(country)'] || 'Ghana';

    // Initialize expanded state for dropoffs (first one expanded by default)
    this.expandedDropoffs = this.dropDetail.map((_, index) => index === 0);
    console.log('this.dropDetail', this.dropDetail);
    // Parse the created date
    const createdDate = new Date(this.orderDetail.createdDate);
    const dateStr = createdDate.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
    });
    const timeStr = createdDate.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    // Map package size
    const packageSizeMap = {
      1: 'Small - Up to 2Kg',
      2: 'Medium - 2Kg To 10Kg',
      3: 'Large - 10Kg To 25Kg',
      4: 'Extra Large - Above 25Kg',
    };

    // Map delivery plan
    const deliveryPlanMap = {
      1: 'Express',
      2: 'Regular',
    };

    // Map sending item
    const sendingItemMap = {
      0: 'Fruits',
      1: 'Documents',
      2: 'Electronics',
      3: 'Clothing',
      4: 'Food',
      5: 'Other',
    };

    this.order = {
      date: dateStr,
      time: timeStr,
      orderNumber: this.orderDetail.order_number,
      status: this.getStatusText(this.orderDetail.orderStatus),
      pickup: {
        name: this.orderDetail.pickUpName || 'N/A',
        address: this.orderDetail.pickUpAddress || 'N/A',
        type: 'Door Pickup',
      },
      dropoff: {
        name: this.dropDetail[0]?.dropOffName || 'N/A',
        address: this.dropDetail[0]?.dropOffAdd || 'N/A',
        plan: deliveryPlanMap[this.dropDetail[0]?.deliveryPlan] || 'Regular',
        item: sendingItemMap[this.dropDetail[0]?.sendingItemKey] || 'Fruits',
        packageSize:
          packageSizeMap[this.dropDetail[0]?.packageSize] ||
          'Medium - 2Kg To 10Kg',
        securityCover: this.dropDetail[0]?.isCoverApplied
          ? 'Enable'
          : 'Disable',
      },
      expectedDelivery: this.orderDetail.expectedDeliveryTime || 'N/A',
    };
  }

  getStatusText(status: number): string {
    switch (status) {
      case 1:
        return 'Processing';
      case 2:
        return 'In transit';
      case 3:
        return 'Delivered';
      case 4:
        return 'Cancelled';
      case 5:
        return 'Re-Scheduled';
      case 6:
        return 'In Transit Hold';
      case 7:
        return 'Returned';
      default:
        return 'Processing';
    }
  }

  // Helper methods for payment summary
  isPhlenuTrustCheckApplied(): boolean {
    return this.orderDetail?.isPhlenuTrustCheckApplied === 1;
  }

  isCashCollectionApplied(): boolean {
    return this.orderDetail?.isCashCollectionApplied === 1;
  }

  getDeliveryFee(): number {
    if (
      this.orderDetail?.isSubtractPriceFromDeliveryFee === 1 &&
      this.orderDetail?.isSubtractPriceFromPickUpFee === 1
    ) {
      return this.orderDetail?.totalCharges || 0;
    } else if (this.orderDetail?.isSubtractPriceFromDeliveryFee === 1) {
      return this.orderDetail?.basePrice || 0;
    } else if (this.orderDetail?.isSubtractPriceFromPickUpFee === 1) {
      return this.orderDetail?.pickupFee || 0;
    }
    return 0;
  }

  getTotalAmount(): string {
    const currency = this.country === 'Nigeria' ? 'NGN' : 'GHS';
    const amount =
      this.orderDetail?.paymentDirection === 2
        ? this.orderDetail?.totalCharges || 0
        : this.orderDetail?.settlementAmount || 0;
    return `${currency} ${amount}`;
  }

  getTotalAmountLabel(): string {
    if (this.orderDetail?.paymentDirection === 0) {
      return 'Money to Be Paid';
    } else if (this.orderDetail?.paymentDirection === 1) {
      return 'Total Reimburse Amount';
    } else {
      return 'Total Amount';
    }
  }

  onBack() {
    this._router.navigate(['/orders'], {
      queryParams: {
        type: 'inter',
      },
    });
  }

  shareOrder() {
    if (this.orderLink) {
      // Copy to clipboard
      navigator.clipboard
        .writeText(this.orderLink)
        .then(() => {
          // Show success snackbar
          this._snackBar.open(
            'Order link copied to clipboard! You can now paste it anywhere.',
            'Close',
            {
              duration: 4000,
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              panelClass: ['success-snackbar'],
            }
          );
        })
        .catch(() => {
          // Fallback for older browsers
          const textArea = document.createElement('textarea');
          textArea.value = this.orderLink;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);

          this._snackBar.open(
            'Order link copied to clipboard! You can now paste it anywhere.',
            'Close',
            {
              duration: 4000,
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              panelClass: ['success-snackbar'],
            }
          );
        });
    } else {
      this._snackBar.open(
        'Order link not available yet. Please try again later.',
        'Close',
        {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          panelClass: ['error-snackbar'],
        }
      );
    }
  }

  hasDoorToDoorDropoff(): boolean {
    return (
      this.dropDetail?.some((item: any) => item?.isDoorToDoorDropOff) || false
    );
  }

  getFormattedExpectedDelivery(dropLocation: any): string {
    if (dropLocation?.expectedDeliveryTime) {
      const deliveryDate = new Date(dropLocation.expectedDeliveryTime);
      const dateStr = deliveryDate.toLocaleDateString('en-US', {
        day: '2-digit',
        month: 'short',
      });
      const timeStr = deliveryDate.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
      return `${dateStr}, ${timeStr}`;
    }
    return 'N/A';
  }

  getDeliveryPlan(deliveryPlan: number): string {
    const deliveryPlanMap = {
      1: 'Express',
      2: 'Regular',
      3: 'Saver',
    };
    return deliveryPlanMap[deliveryPlan] || 'Regular';
  }

  getSendingItem(sendingItemKey: number): string {
    const item = this.packageItems.find((item) => item.id === sendingItemKey);
    return item ? item.title : 'Fruits';
  }

  getSendingItemIcon(sendingItemKey: number): string {
    const item = this.packageItems.find((item) => item.id === sendingItemKey);
    return item ? item.images : 'assets/images/icons/fruits.png';
  }

  getPackageSizeIcon(packageSize: number): string {
    const size = bulkPackageSizes.find((size) => size.id === packageSize);
    return size
      ? size.icon
      : 'assets/images/packageSizes/bulk/packageMedium.png';
  }

  getPackageSize(packageSize: number): string {
    const size = bulkPackageSizes.find((size) => size.id === packageSize);
    return size ? size.name + ' - ' + size.info : 'Medium - 2Kg To 10Kg';
  }

  toggleDropoffExpansion(index: number): void {
    this.expandedDropoffs[index] = !this.expandedDropoffs[index];
  }

  isDropoffExpanded(index: number): boolean {
    return this.expandedDropoffs[index] || false;
  }

  getProgressBarWidth(dropLocation?: any): number {
    if (!dropLocation) return 33.33;

    const status = dropLocation.dropStatus;

    // Progress based on 4 steps with exact percentages as specified
    switch (status) {
      case 1: // Processing - 33.33% (first step)
        return 31;
      case 2: // In transit - 66.66% (second step)
        return 65;
      case 3: // Delivered - 100% (all steps)
        return 100;
      case 4: // Cancelled - 33.33% (first step)
        return 31;
      case 5: // Re-Scheduled - 66.66% (second step)
        return 65;
      case 6: // In Transit Hold - 66.66% (second step)
        return 65;
      case 7: // Returned - 33.33% (first step)
        return 31;
      case 8: // Enroute to PickUp - 33.33% (first step)
        return 31;
      default: // Default to first step
        return 31;
    }
  }

  getStepStatus(
    stepId: number,
    dropLocation?: any
  ): 'completed' | 'current' | 'pending' {
    if (!dropLocation)
      return stepId === 1 ? 'completed' : stepId === 2 ? 'current' : 'pending';

    const status = dropLocation.dropStatus;

    // console.log('status', status);
    // console.log('stepId', stepId);

    switch (status) {
      case 1: // Processing - first step completed, second step current
        return stepId === 1
          ? 'completed'
          : stepId === 2
          ? 'current'
          : 'pending';
      case 2: // In transit - first two steps completed, third step current
        return stepId <= 2 ? 'completed' : stepId === 3 ? 'current' : 'pending';
      case 3: // Delivered - all steps completed
        return 'completed';
      case 4: // Cancelled - first step completed, second step current
        return stepId === 1
          ? 'completed'
          : stepId === 2
          ? 'current'
          : 'pending';
      case 5: // Re-Scheduled - first two steps completed, third step current
        return stepId <= 2 ? 'completed' : stepId === 3 ? 'current' : 'pending';
      case 6: // In Transit Hold - first two steps completed, third step current
        return stepId <= 2 ? 'completed' : stepId === 3 ? 'current' : 'pending';
      case 7: // Returned - first step completed, second step current
        return stepId === 1
          ? 'completed'
          : stepId === 2
          ? 'current'
          : 'pending';
      case 8: // Enroute to PickUp - first step completed, second step current
        return stepId === 1
          ? 'completed'
          : stepId === 2
          ? 'current'
          : 'pending';
      default: // Default state - first step completed, second step current
        return stepId === 1
          ? 'completed'
          : stepId === 2
          ? 'current'
          : 'pending';
    }
  }

  shareDropTracking(dropLocation: any, index: number) {
    console.log('dropLocation', dropLocation);

    // Prefer a drop-specific token/link if provided in API; otherwise fallback to consolidated orderLink
    const dropToken = dropLocation?.token || dropLocation?.trackingToken || '';
    const isGhana =
      (this.countryFromLocal || this.country || '').toLowerCase() === 'ghana';
    const basePath = isGhana
      ? '/inter-regional-order-tracking/order-details'
      : '/inter-state-order-tracking/order-details';

    const urlToCopy =
      dropLocation?.dropLink && `${dropLocation.dropLink}`.trim().length > 0
        ? dropLocation.dropLink
        : dropToken
        ? `${location.origin}${basePath}?token=${encodeURIComponent(dropToken)}`
        : this.orderLink;

    if (!urlToCopy) {
      this._snackBar.open(
        'Tracking link not available yet. Please try again later.',
        'Close',
        {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          panelClass: ['error-snackbar'],
        }
      );
      return;
    }

    navigator.clipboard
      .writeText(urlToCopy)
      .then(() => {
        this._snackBar.open('Tracking link copied to clipboard!', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          panelClass: ['success-snackbar'],
        });
      })
      .catch(() => {
        const textArea = document.createElement('textarea');
        textArea.value = urlToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        this._snackBar.open('Tracking link copied to clipboard!', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          panelClass: ['success-snackbar'],
        });
      });
  }
}
